import { render, staticRenderFns } from "./TextareaMarkdown.vue?vue&type=template&id=33213b7a&"
import script from "./TextareaMarkdown.vue?vue&type=script&lang=js&"
export * from "./TextareaMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports